import {
  PowerListConfigurationKeys,
  PowerListConfigurations,
  POWER_LIST_NAMESPACE,
} from '@epicuro-next/constants/rule-engine/product-list-rules';
import { selectConfigurationValueFrom } from '@epicuro-next/platform/configuration';

export const selectHideExcludeButton = selectConfigurationValueFrom<
  PowerListConfigurationKeys.HideExcludeButton,
  PowerListConfigurations
>(POWER_LIST_NAMESPACE, PowerListConfigurationKeys.HideExcludeButton, false);
